import { render, staticRenderFns } from "./ServiceSchools.vue?vue&type=template&id=7a651c0c"
import script from "./ServiceSchools.vue?vue&type=script&lang=js"
export * from "./ServiceSchools.vue?vue&type=script&lang=js"
import style0 from "./ServiceSchools.vue?vue&type=style&index=0&id=7a651c0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports